export const calculateRemaining = (maxLength, value = '') =>
    Math.max(0, maxLength - value.length);
export const calculateApproachingLimit = (
    maxLength,
    remaining,
    limitPercentage = 0.1,
) => remaining <= limitPercentage * maxLength;
export const calculateReachedLimit = (remaining) => remaining <= 0;
